import { render, staticRenderFns } from "./button.vue?vue&type=template&id=5b13b8a2&"
import script from "./button.vue?vue&type=script&lang=ts&"
export * from "./button.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Source\\WebMap\\Monthly\\Sites\\WebMap\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b13b8a2')) {
      api.createRecord('5b13b8a2', component.options)
    } else {
      api.reload('5b13b8a2', component.options)
    }
    module.hot.accept("./button.vue?vue&type=template&id=5b13b8a2&", function () {
      api.rerender('5b13b8a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "Script/Components/MapView/Application/button.vue"
export default component.exports